// types
import { Contract } from '../../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// ui
import { Table, TableHeader, TableProps } from '../../../ui/Table/Table';

// headers
import { getHeaders } from './TableBasicContracts.headers';

// props
export interface TableBasicContractsProps extends Omit<TableProps, 'headers'> {
	data: Contract[];
}

export const TableBasicContracts = ({ data = [], ...props }: TableBasicContractsProps) => {
	// hooks
	const { t } = useTranslation();

	// vars
	const headers: TableHeader[] = getHeaders({ t });

	return <Table {...props} headers={headers} data={data} />;
};
